<template>
  <section class="section text-center bg-white">
    <div class="container">
      <h1 class="fw-bold mb-4">Welcome to the Nutrient&nbsp;Navigator</h1>
      <p class="lead mx-auto">
Explore how much nitrogen and phosphorus find their way from agricultural fields to freshwater systems—and how to reduce the water footprint of your organisation. The Nutrient Navigator combines scientific data with an interactive global map to visualise how much nitrogen and phosphorus applied on agricultural fields typically end up in freshwater systems. Use the Nutrient Navigator to understand where nutrient pollution occurs and to set science-based water quality targets.
      </p>
    </div>
  </section>

  <section class="py-5 text-center bg-primary">
    <div class="container">
      <RouterLink to="/map" class="map-btn">
        <div class="goto">
          view the map<br/><i class="fa-solid fa-caret-right"></i><i class="fa-solid fa-caret-right"></i>
        </div>
      </RouterLink>
    </div>
  </section>

  <section class="section bg-light">
    <div class="container">
      <div class="row g-4">
        <div class="col-lg-6">
          <RouterLink to="concern" class="card p-4 h-100">
            <h5 class="card-title">Nutrient pollution: a major freshwater quality concern</h5>
            <p>
              Nitrogen and phosphorus are essential for life, but excess use can lead to water pollution.
            </p>
            <span class="btn btn-link px-0">read more <i class="fa-solid fa-arrow-right"></i></span>
          </RouterLink>
        </div>
        <div class="col-lg-6">
          <RouterLink to="my-load" class="card p-4 h-100">
            <h5 class="card-title">What is my nutrient load?</h5>
            <p>
              To comply with SBTN’s water quality target, companies need to know their nutrient contributions.
            </p>
            <span class="btn btn-link px-0">read more <i class="fa-solid fa-arrow-right"></i></span>
          </RouterLink>
        </div>
        <div class="col-lg-6">
          <RouterLink to="data" class="card p-4 h-100">
            <h5 class="card-title">How did the data come about?</h5>
            <p>
              Load estimates come from peer-reviewed studies by Mekonnen and Hoekstra using global agricultural models.
            </p>
            <span class="btn btn-link px-0">read more <i class="fa-solid fa-arrow-right"></i></span>
          </RouterLink>
        </div>
        <div class="col-lg-6">
          <RouterLink to="crops" class="card p-4 h-100">
            <h5 class="card-title">What crops are in what crop group?</h5>
            <p>
              Crop groups are based on FAOSTAT categories, combining 126 crops to reduce data uncertainty.
            </p>
            <span class="btn btn-link px-0">read more <i class="fa-solid fa-arrow-right"></i></span>
          </RouterLink>
        </div>
      </div>
    </div>
  </section>

  <div class="bottom-hide"></div>
  <div class="bottom-row bg-white">
    <span class="nut">Nutrient Navigator</span>
    <span class="opt">a product from</span>
    <a href="https://sciencebasedtargetsnetwork.org/"><img src="../assets/img/sbtn-logo-yellow.svg"/></a>
    <span class="opt">and</span>
    <a href="https://www.waterfootprint.org/"><img src="../assets/img/wfn-logo.png"/></a>
  </div>
</template>

<script>
export default {
  name: "Home"
}
</script>

<style lang="scss">
body {
  background-color: #f8f9fa;
}
p {
  line-height: 1.7;
}
.section {
  padding: 4rem 1rem;
}
.lead {
  max-width: 1160px;
}
.col-lg-6 {
  .card {
    background-color: #ffffff;
    border: none;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    text-decoration: none;
    .card-title {
      color: #7a0403;
    }
    .btn-link {
      font-variant: small-caps;
      text-decoration: none;
    }
    &:hover {
      .card-title {
        text-decoration: underline;
        text-decoration-color: var(--bs-primary);
      }
      .btn-link {
        color: var(--bs-primary);
        text-decoration: underline;
      }
    }
  }
}

.map-btn {
  display: block;
  position: relative;
  width: 90%;
  max-width: 407px;
  height: 170px;
  margin: auto;
  border: 2px solid #fff;
  border-radius: var(--bs-border-radius);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  font-variant: small-caps;
  background-image: url(../assets/img/map.png);
  .goto {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0 10px;
    text-align: center;
    font-weight: bolder;
    font-size: 1.5em;
    color: var(--bs-body-color);
    background-color: rgba(255, 255, 255, 0.8);
  }
  &:hover .goto {
    background-color: rgba(255, 255, 255, 0.9);
  }
}
.bottom-hide {
  height: 67px;
}
.bottom-row {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 67px;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 700;
  .nut {
    display: none;
    font-size: 1.1em;
  }
  .opt {
    display: none;
    font-variant: small-caps;
  }
  img {
    height: 40px;
  }
}

.content-wrapper {
  max-width: 1050px;
  margin: auto;
  border-bottom-left-radius: var(--bs-border-radius-lg);
  border-bottom-right-radius: var(--bs-border-radius-lg);
  padding: 2rem 1rem 4rem;
  h1 {
    color: #7a0403;
    text-decoration: underline;
    text-decoration-color: var(--bs-primary);
    text-decoration-thickness: 3px;
  }
}

@media (min-width: 992px) {
  p {
    line-height: 1.9;
  }
  .card p {
    font-size: 1.1rem;
  }
  .content-wrapper p {
    font-size: 1.1rem;
  }
  .bottom-row {
    .nut {
      display: block;
    }
    .opt {
      display: block;
    }
    img {
      height: 50px;
    }
  }
}
</style>
